import { View } from "@react-pdf/renderer";

import { styles } from "components/Resume/ResumePDF/styles";
import type { ResumeCustom } from "lib/redux/types";
import { ResumePDFDescription } from "./common";
import { TemplateSixteenSection } from "./common/sections";

export const Custom = ({
  heading,
  custom,
  themeColor,
}: {
  heading: string;
  custom: ResumeCustom;
  themeColor: string;
}) => {
  const { descriptions } = custom;

  return (
    <TemplateSixteenSection themeColor={themeColor} heading={heading}>
      <View style={{ ...styles.flexCol }}>
        <ResumePDFDescription items={descriptions} />
      </View>
    </TemplateSixteenSection>
  );
};
